import { FIELD_TYPES } from "constants/template-field-type";
export default {
    creditCardVisibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Show main CTA additional text"
    },
    whatWouldVisibility: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Show CTA subtitle text"
    }
};
